import { DecoderHelpers } from '@headless-workspace/utils';
import { HTMLString } from '../../../server';
import { ContentAsset, ContentAssetDTO, ContentAssets } from './ContentAssetsDTO';

export type ContentAssetValue = Readonly<{
    id: string;
    content: HTMLString;
    title?: string;
}>;

export const mapContentAssetsValue = (dto: ContentAssets): ContentAssetValue[] => {
    const assets = DecoderHelpers.safeParseArray(dto.assets, ContentAssetDTO);

    return assets.map((dto: ContentAsset) => ({
        id: dto.id,
        content: HTMLString(dto.body),
        title: dto.title ?? '',
    }));
};
